export const ACTION_TYPES = {
  SET_SEARCHED_RESULTS: 'SET_SEARCHED_RESULTS',
  SET_CATEGORIES:'SET_CATEGORIES',
}